import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const BurgerIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.625 4H12.375C12.7188 4 13 3.55 13 3C13 2.45 12.7188 2 12.375 2H3.625C3.28125 2 3 2.45 3 3C3 3.55 3.28125 4 3.625 4ZM12.375 12H3.625C3.28125 12 3 12.45 3 13C3 13.55 3.28125 14 3.625 14H12.375C12.7188 14 13 13.55 13 13C13 12.45 12.7188 12 12.375 12ZM12.375 7.00002H3.625C3.28125 7.00002 3 7.45002 3 8.00002C3 8.55001 3.28125 9.00002 3.625 9.00002H12.375C12.7188 9.00002 13 8.55001 13 8.00002C13 7.45002 12.7188 7.00002 12.375 7.00002Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default BurgerIcon;
